import type { QueryClient } from "@tanstack/react-query";
import { api, ApiError, clientFetch, type ClientRequest } from "./api.ts";
import { keys } from "./queries.ts";
import { toast } from "./store.ts";

/** "Check now": the server fetches, or hands us the request when the site only answers browsers. */
export async function refreshLot(qc: QueryClient, id: string) {
  try {
    const r = await api<{ status: "ok" } | { status: "needs_client"; request: ClientRequest }>(`/lots/${id}/refresh`, { method: "POST" });
    if (r.status === "needs_client") {
      const f = await clientFetch(r.request);
      const res = await api<{ ok: boolean; error?: string }>(`/assist/${id}`, { method: "POST", body: f });
      if (!res.ok) {
        toast(f.status === 0 ? "The site didn't answer this browser. Open the lot and use the bookmarklet." : `Couldn't read the lot: ${res.error ?? `HTTP ${f.status}`}`, { tone: "error" });
        return;
      }
    }
    toast("Checked just now");
  } catch (e) {
    toast(e instanceof ApiError ? e.message : `Couldn't check: ${(e as Error).message}`, { tone: "error" });
  } finally {
    await Promise.all([qc.invalidateQueries({ queryKey: keys.lot(id) }), qc.invalidateQueries({ queryKey: keys.lots }), qc.invalidateQueries({ queryKey: keys.issues })]);
  }
}
